import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../features/slices/applicationSlice";
import { TFunction } from "i18next";

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showConfirmCreateContractorAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.contractors.create.title'),
                message: translate('alerts.contractors.create.message'),
                icon: 'info',
                confirmText: translate('alerts.contractors.create.confirmText'),
                cancelText: translate('alerts.contractors.create.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };

    const showConfirmEditContractorAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.contractors.edit.title'),
                message: translate('alerts.contractors.edit.message'),
                icon: 'info',
                confirmText: translate('alerts.contractors.edit.confirmText'),
                cancelText: translate('alerts.contractors.edit.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    const showConfirmDeleteContractorAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.contractors.delete.title'),
                message: translate('alerts.contractors.delete.message'),
                icon: 'error',
                confirmText: translate('alerts.contractors.delete.confirmText'),
                cancelText: translate('alerts.contractors.delete.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    const showConfirmCreateResponsibleAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.responsible.create.title'),
                message: translate('alerts.responsible.create.message'),
                icon: 'info',
                confirmText: translate('alerts.responsible.create.confirmText'),
                cancelText: translate('alerts.responsible.create.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };
    
    const showConfirmEditResponsibleAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.responsible.edit.title'),
                message: translate('alerts.responsible.edit.message'),
                icon: 'info',
                confirmText: translate('alerts.responsible.edit.confirmText'),
                cancelText: translate('alerts.responsible.edit.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };


    const showConfirmDeleteResponsibleAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.responsible.delete.title'),
                message: translate('alerts.responsible.delete.message'),
                icon: 'error',
                confirmText: translate('alerts.responsible.delete.confirmText'),
                cancelText: translate('alerts.responsible.delete.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    return {
        showConfirmCreateContractorAlert,
        showConfirmEditContractorAlert,
        showConfirmDeleteContractorAlert,
        showConfirmEditResponsibleAlert,
        showConfirmCreateResponsibleAlert,
        showConfirmDeleteResponsibleAlert
    };
};

export default useAlerts;